export default "__VITE_ASSET__C8DG5QPF__"